var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { getStore } from "./bodyFixedStore";
import { DialogMain, Wrap } from "./styles";
export default class Dialog extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            show: this.props.show
        };
        this.toggleShow = (show) => {
            if (typeof show === "boolean") {
                if (show !== this.state.show) {
                    this.setState({ show });
                }
            }
            else {
                this.setState(prevState => ({
                    show: !prevState.show
                }));
            }
        };
        this.show = () => this.toggleShow(true);
        this.hide = () => this.toggleShow(false);
        this.handleRootElmClick = (e) => {
            const { onClick, show, isClickBGHide } = this.props;
            if (typeof show === "undefined" &&
                isClickBGHide &&
                this.state.show &&
                e.target && this.rootElm) {
                this.toggleShow(false);
            }
            if (typeof onClick !== "undefined" && e.target && this.rootElm) {
                onClick(e);
            }
        };
        this.getContentAttributes = () => {
            const { contentAttributes = {} } = this.props;
            const { children } = contentAttributes, attributes = __rest(contentAttributes, ["children"]);
            return attributes;
        };
    }
    componentWillReceiveProps(nextProps) {
        const { show } = nextProps;
        if (typeof show === "boolean" && typeof this.props.show === "boolean" && typeof this.state.show === "boolean") {
            if (show !== this.props.show && show !== this.state.show) {
                this.setState({ show });
            }
        }
    }
    componentWillUpdate(nextProps, nextState) {
        if (typeof nextProps.isAutoFixedBody === "boolean" && typeof nextState.show === "boolean" && typeof this.state.show === "boolean") {
            if (nextProps.isAutoFixedBody && nextState.show !== this.state.show) {
                if (nextState.show) {
                    getStore().stopScroll();
                }
                else {
                    getStore().revertScroll();
                }
            }
        }
    }
    componentWillUnmount() {
        const { isAutoFixedBody } = this.props;
        const { show } = this.state;
        if (isAutoFixedBody && show) {
            getStore().revertScroll();
        }
    }
    render() {
        const _a = this.props, { onClickCB, className, style, contentAttributes, show, isAutoFixedBody } = _a, otherAttributes = __rest(_a, ["onClickCB", "className", "style", "contentAttributes", "show", "isAutoFixedBody"]);
        const { children, isClickBGHide } = otherAttributes, attributes = __rest(otherAttributes, ["children", "isClickBGHide"]);
        return (React.createElement(Wrap, Object.assign({ show: this.state.show }, attributes, { style: style, ref: rootElm => (this.rootElm = rootElm || undefined), onClick: this.state.show ? this.handleRootElmClick : void 0 }),
            React.createElement(DialogMain, Object.assign({ show: this.state.show, ref: contentElm => (this.contentElm = contentElm || undefined), onClick: () => {
                    if (onClickCB) {
                        onClickCB(this);
                    }
                } }, contentAttributes, this.getContentAttributes()), this.props.children)));
    }
}
Dialog.defaultProps = {
    isAutoFixedBody: false,
    className: "",
    onClickCB: () => { },
    onClick: () => { },
    show: false
};
